import { FormikInsurance, Questionnaire } from "src/types";

export const toQuestionnaireModified = (
  questionnaire: Questionnaire,
  values: FormikInsurance
): Questionnaire => {
  const questionnaireCopy = structuredClone(questionnaire) as Questionnaire;

  questionnaireCopy.questionario.domande.forEach((domanda) => {
    const match = values.coherenceQuestions.find(
      (q) => q.id === domanda.idDomanda
    );
    if (!match?.answer) return;

    domanda.risposte?.forEach((risposta) => {
      risposta.selezionata = risposta.idRisposta.toString() === match.answer;
    });
  });

  return questionnaireCopy;
};
